import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const perDiemPastDueAcknowledgeReasonsAdapter = getAdapter();

const perDiemPastDueAcknowledgeReasonsSlice = createSlice({
  name: 'perDiemPastDueAcknowledgeReasons',
  initialState: perDiemPastDueAcknowledgeReasonsAdapter.getInitialState(),
  reducers: {
    setPerDiemPastDueAcknowledgeReasons: (state, { payload: { perDiemPastDueAcknowledgeReasons } }) => {
      perDiemPastDueAcknowledgeReasonsAdapter.setAll(state, perDiemPastDueAcknowledgeReasons);
    },
  },
});

const selectors = perDiemPastDueAcknowledgeReasonsAdapter.getSelectors(({ perDiemPastDueAcknowledgeReasons }) => perDiemPastDueAcknowledgeReasons);

export const getPerDiemPastDueAcknowledgeReasons = (state) => selectors.selectAll(state);

export const {
  setPerDiemPastDueAcknowledgeReasons,
} = perDiemPastDueAcknowledgeReasonsSlice.actions;

export default perDiemPastDueAcknowledgeReasonsSlice.reducer;